import styled from 'styled-components';

export const Style = styled.div`
  background: white;
  width: 227px;
  display: flex;
  flex-direction: column;

  .close-header {
    display: flex;
    justify-content: flex-end;

    svg {
      width: 10px;
      cursor: pointer;
    } 
  }

  .section {
    flex: 1;
    display: flex;
    flex-direction: column;

    .body {
      display: flex;
      flex-direction: column;

      .active-node-container {
        display: flex;
        flex-direction: column;

        svg {
          fill: #98A2B3;
          cursor: pointer;
        }

        .header-second {
          label {
            font-size: 12px;
            font-weight: 600;
            margin-bottom: 4px;
            color: #6C737F; 
          }

          h1 {
            font-size: var(--font-size-lg);
            font-weight: 500;
            color: #101828;
            margin-bottom: var(--size);
          }
        }

        .sources-label {
          color: #6C737F;
          font-weight: 600;
          font-size: 12px;
          margin-bottom: 8px;
        }

        .sources {
          display: flex;
          flex-direction: column;
          gap: 8px;
          
          .source {
            a {
              color: #2E90FA;
              font-size: 14px;
              font-weight: 500;
              margin-bottom: 0px;
            }
          }
        }
      }
    }
  }
`;
